import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  ComboService,
  DesignphotoService,
  SalesReturnService,
} from "../../../services/index";
import { elementAt } from "rxjs/operator/elementAt";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "addEditPurchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addEditSalesReturn.html",
})
export class AddEditSalesReturn {
  row: any;
  data: any;
  designdata: any = {};
  wodata: any = {
    shirtdno: "",
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    totalmtr: 0,
    totalamt: 0,
    stock: true,
  };
  qualityList: any;
  boxTypeList = ["WITH BOX", "W/O BOX"];
  retTypeList = ["PIECE", "SHORTAGE", "RATE DIFF", "OTHERS"];
  billTypeList = ["WHOLESALE", "RETAIL", "OLIVE","PROFORMAWHOLESALE"];
  goodsTypeTypeList = ["NORMAL RETURN", "DAMAGE RETURN"];
  typeList = ["Mrp", "Rate", "Category", "Barcode"];
  typelist = ["Fresh", "Damage"];
  DamageList=["FACTORY DAM", "CONSUMER DAM", "CUSTOMER DAM", "ASPER ORD", "NON ORD"]
  type = "";
  addToStock = true;
  narr: boolean;
  colorList: any;
  designnoList = [];
  codeList: any;
  widthList: any[];
  partyList = [];
  seasonList = [];
  filterList = [];
  inv_date = '';
  dcdt = '';
  dif_date = '';
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  returndata: any = {
    type: "Category",
    design_type: "Fresh",
    addToStock: true,
    ftotpcs: 0,
    party_name: "",
    htotpcs: 0,
    totpcs: 0,
    totamt: 0,
    boxless: 0,
    taxamt: 0,
    invoice_no: 0,
    disamt: 0,
    disper: 0,
    roundoff: 0,
    retamt: 0,
    transport: 0,
    tot_amt: 0,
    oth_amt: 0,
    narration: "",
    return_type: "",
    box_type: "",
    retbill_type: "",
    agentid: 0,
    party_id: 0,
    ded_tot: 0,
    ret_type: "PIECE"
  };
  salesdata: any = {
    type: "Category",

    design_type: "Fresh",
    addToStock: true,
    party_name: "",
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    ftotpcs: 0,
    htotpcs: 0,
    totpcs: 0,
    totamt: 0,
    return_type: "",
    box_type: "",
    view_type: "PIECE",
    dam_type: ""
  };

  designList = [];
  multiList = [];

  mode: string;
  saveEvent: any;
  ret_id: any;
  barcodeVal = true;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  invoiceList = [];
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;
  @Input() active = false;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.data = val["list"];
    for (let i = 0; i < this.data.length; i++) {
      this.data[i].tabevent = "";
    }
    if (this.mode == "Convert_type") {
      this.returndata.party_name = designdata.party_name;
      this.returndata.retdate = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.ret_id = designdata.ret_id;
    }
    if (this.mode == "Edit" || this.mode == "View") {
      this.returndata = designdata;

      this.returndata.retamt = parseInt(designdata.retamt);



      //this.salesdata = designdata;
      this.returndata.totpcs =
        this.returndata.ftotpcs + this.returndata.htotpcs;
      this.returndata.addToStock = true;
      this.salesdata.invoice_no = this.returndata.invoice_no;

      this.salesdata.type = "Category";
      // this.returndata.retdate = this.datePipe.transform(
      //   this.returndata.addedon,
      //   "yyyy-MM-dd"
      // );
      this.loaddesignList(this.returndata.creditid);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesReturnService,
    private comboservice: ComboService,
    private designservice: DesignphotoService
  ) { }
  ngOnInit() {
    this.tableScroll();
    if (this.mode == "Add" || this.mode == "Convert_type") {
      this.salesdata = {
        type: "Category",
        filter: "",
        design: "",
        invoice_no: "",
        design_type: "Fresh",
        addToStock: true,
        f36: 0,
        f38: 0,
        f40: 0,
        f42: 0,
        f44: 0,
        f46: 0,
        h36: 0,
        h38: 0,
        h40: 0,
        h42: 0,
        h44: 0,
        h46: 0,
        ftotpcs: 0,
        htotpcs: 0,
        totpcs: 0,
        totamt: 0,

      };
      this.type = this.salesdata.design_type;
      this.returndata.retdate = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      // this.getAuto();
    }

    this.getPartyList();
    this.getSeasonList();
    if (this.mode != "View") {
      this.getDesignNoList();
    }
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 800);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (
      nextEl == "f36" ||
      nextEl == "f38" ||
      nextEl == "f40" ||
      nextEl == "f42" ||
      nextEl == "f44" ||
      nextEl == "f46" ||
      nextEl == "h36" ||
      nextEl == "h38" ||
      nextEl == "h40" ||
      nextEl == "h42" ||
      nextEl == "h44" ||
      nextEl == "h46"
    ) {
      $("#" + nextEl).select();
    } else if (nextEl == "add") {
      //  $('#pack' + nextEl).focus();

      this.pushrow();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);
    }
  }

  loaddesignList(id) {
    let params = {
      creditid: id,
      order_type: "Order Form",
      page: 1,
      start: 0,
      limit: 100,
    };
    this.salesservice.getSiRtnEntryGridShirtSizeDet(params).then((res: any) => {
      this.designList = res;
       this.designList = this.designList.map(item => ({
      ...item,
      rack_allowed: Boolean(Number(item.rack_allowed))
    }));

      this.calcTotal();
    });
  }

  calcTot() {

    this.salesdata.ftotpcs =
      this.salesdata.f36 +
      this.salesdata.f38 +
      this.salesdata.f40 +
      this.salesdata.f42 +
      this.salesdata.f44 +
      this.salesdata.f46;
    this.salesdata.htotpcs =
      this.salesdata.h36 +
      this.salesdata.h38 +
      this.salesdata.h40 +
      this.salesdata.h42 +
      this.salesdata.h44 +
      this.salesdata.h46;
    this.returndata.ftotpcs = this.salesdata.ftotpcs;
    this.returndata.htotpcs = this.salesdata.htotpcs;
    this.salesdata.totpcs = this.salesdata.ftotpcs + this.salesdata.htotpcs;
    this.returndata.totpcs = this.salesdata.totpcs;
    this.salesdata.totamt =
      this.salesdata.ftotpcs * this.salesdata.fsrate +
      this.salesdata.htotpcs * this.salesdata.hsrate;
    this.returndata.totamt = this.salesdata.totamt;
    this.returndata.totamt = this.salesdata.totamt;
  }
  addStock() {
    if (this.addToStock) {
      this.addToStock = false;
    } else {
      this.addToStock = true;
    }
    this.salesdata.addToStock = this.addStock;
  }
    selectAll(event: any) {
    // console.log(event.target.checked, "check Event", this.designList)
    this.designList = this.designList.map(item => ({
      ...item,
      rack_allowed: event.target.checked
    }));
    console.log(event.target.checked, this.designList)
  }
  pushshortagerow(){
    let row ={
      barcode: "NEW",
      return_type: this.returndata.return_type,
      design_id: 0,
      invoiceno: 0,
      box_type: '',
      view_type: 'SHORTAGE',
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      hqty:0,
      totqty: 1,
      totamt: 0,
      fsrate: 0,
      hsrate: 0,
    }
    this.designList.push({...row})
    console.log("caaaaaaaaaaaales",this.designList)

  }
  calcShortage(val,ind){
    this.returndata.totamt = this.salesdata.totamt + val
    this.designList[ind].fsrate = val
    this.designList[ind].hsrate = val
  }
  pushrow() {

    //     let row = {
    //         design_id: this.salesdata.design_id,
    //  //       dispName: this.salesdata.design,
    //         design_no: this.salesdata.design,
    //         dcid: this.salesdata.dcid,
    //         categoryid: this.salesdata.categoryid,
    //         filterret: this.salesdata.type,
    //         filterBy: this.salesdata.filter,
    //         invoiceno: this.salesdata.invoice_no,
    //         barcode: 'NEW',
    //         f36: this.salesdata.f36,
    //         f38: this.salesdata.f38,
    //         f40: this.salesdata.f40,
    //         f42: this.salesdata.f42,
    //         f44: this.salesdata.f44,
    //         f46: this.salesdata.f46,
    //         fqty: this.salesdata.ftotpcs,
    //         h36: this.salesdata.h36,
    //         h38: this.salesdata.h38,
    //         h40: this.salesdata.h40,
    //         h42: this.salesdata.h42,
    //         h44: this.salesdata.h44,
    //         h46: this.salesdata.h46,
    //         hqty: this.salesdata.htotpcs,
    //         totqty: this.salesdata.totpcs,
    //         totamt: this.salesdata.totamt,
    //         type: this.salesdata.design_type,
    //         fsrate: this.salesdata.fsrate,
    //         hsrate: this.salesdata.hsrate

    //     };
    let row = {
      design_id: this.salesdata.design_id,
      dispName: this.salesdata.design,
      design_no: this.salesdata.design,
      dcid: this.salesdata.dcid,
      categoryid: this.salesdata.categoryid,
      filterret: this.salesdata.type,
      filterBy: this.salesdata.filter,
      invoiceno: this.salesdata.invoice_no,
      barcode: "NEW",
      f36: this.salesdata.f36,
      f38: this.salesdata.f38,
      f40: this.salesdata.f40,
      f42: this.salesdata.f42,
      f44: this.salesdata.f44,
      f46: this.salesdata.f46,
      fqty: this.salesdata.ftotpcs,
      h36: this.salesdata.h36,
      h38: this.salesdata.h38,
      h40: this.salesdata.h40,
      h42: this.salesdata.h42,
      h44: this.salesdata.h44,
      h46: this.salesdata.h46,
      hqty: this.salesdata.htotpcs,
      totqty: this.salesdata.totpcs,
      totamt: this.salesdata.totamt,
      type: this.type,
      fsrate: this.salesdata.fsrate,
      hsrate: this.salesdata.hsrate,
      barcodedel: this.salesdata.barcodedel,
      return_type: this.returndata.return_type,
      box_type: this.returndata.box_type,
      view_type: this.salesdata.view_type,
      rack_allowed: false
    };

    let row1 = { ...row };
    let originalRow = { ...row };
    let sizeList = [
      "f36",
      "f38",
      "f40",
      "f42",
      "f44",
      "f46",
      "h36",
      "h38",
      "h40",
      "h42",
      "h44",
      "h46",
    ];
    // Inv No wise Pcs Pushing in The row (Barcode don't knowing)

    if (
      this.salesdata.design !== "" &&
      this.salesdata.invoice_no !== "" &&
      this.salesdata.f36 !== "" &&
      this.salesdata.h36 !== "" &&
      this.salesdata.f38 !== "" &&
      this.salesdata.h38 !== "" &&
      this.salesdata.h40 !== "" &&
      this.salesdata.f40 !== "" &&
      this.salesdata.h42 !== "" &&
      this.salesdata.f42 !== "" &&
      this.salesdata.h42 !== "" &&
      this.salesdata.h44 !== "" &&
      this.salesdata.f46 !== "" &&
      this.salesdata.h46 !== ""
    ) {
      if (
        this.returndata.party_name == "" ||
        this.returndata.box_type == "" ||
        this.returndata.return_type == ""
      ) {
        swal("Please Enter Party Name");
      } else {
        let that = this;

        sizeList.forEach((el) => {
          if (row1[el] > 0) {
            let rowPush = { ...originalRow };
            let rowCreate = parseInt(row1[el]);
            // rowPush.totamt = rowPush.totamt/rowPush.totqty;
            let designExists = that.designnoList.filter(
              (element) => element.design_id == row1.design_id
            );


            for (let i = 0; i < rowCreate; i++) {
              rowPush[el] = 1;
              let size = el.substring(1, 0);
              if (size == "f") {
                rowPush.fqty = 1;
                rowPush.hqty = 0;

                if (designExists) {
                  rowPush.totamt = designExists[0].fsrate;
                }
              } else {
                rowPush.fqty = 0;
                rowPush.hqty = 1;

                if (designExists) {
                  rowPush.totamt = designExists[0].hsrate;
                }
              }
              rowPush.totqty = 1;

              sizeList.forEach((el1) => {
                if (el != el1) {
                  rowPush[el1] = 0;
                }
              });
              that.designList.push(rowPush);
            }
          }
        });
        if (this.returndata.retbill_type == "OLIVE" && this.barcodeVal == true) {
          that.designList.push(row1);
          this.designList[this.designList.length - 1].inv_date = this.inv_date
          this.designList[this.designList.length - 1].dif_days = this.dif_date
          this.designList[this.designList.length - 1].dcdt = this.dcdt

        }
        else if (this.barcodeVal == true) {

          if (this.designList.length > 0 && this.returndata.retbill_type == 'WHOLESALE') {
            this.designList[this.designList.length - 1].inv_date = this.inv_date
            this.designList[this.designList.length - 1].dif_days = this.dif_date
            this.designList[this.designList.length - 1].dcdt = this.dcdt
            this.getReturnDeduction();

          }
          this.inv_date = '';
          this.dif_date = '';
          this.dcdt = '';
        }
        else if (this.barcodeVal == false) {
          if (this.returndata.retbill_type == 'WHOLESALE' || this.returndata.retbill_type == 'OLIVE') {
            let temp_size = '';
            sizeList.forEach((el) => {
              if (row1[el] > 0) {
                temp_size = el;
              }
            });

            let params = {
              inv_no: this.salesdata.invoice_no,
              design_id: this.salesdata.design_id,
              party_id: this.returndata.party_id,
              size: temp_size,
              ret_date: this.returndata.retdate,
              inv_type: this.returndata.retbill_type
            };

            this.salesservice.getInvnoDate(params).then((res: any) => {
              if (this.designList.length > 0) {
                this.designList[this.designList.length - 1].inv_date = res.inv_date
                this.designList[this.designList.length - 1].dif_days = res.dif_days
                this.designList[this.designList.length - 1].dcdt = res.dcdt
                //Only Wholesale
                if (this.returndata.retbill_type == 'WHOLESALE') {
                  this.getReturnDeduction();
                }
                //That Below set Call From that api after
              }

            });
          }

        }






        that.calcTotal();
        that.salesdata = {
          type: "Category",
          filter: "",
          design: "",
          invoice_no: "",
          rc_no: "",
          design_type: "Fresh",
          wo_type: "Sales",
          stk_pcs: "",
          file_name: "",
          addToStock: true,
          f36: 0,
          f38: 0,
          f40: 0,
          f42: 0,
          f44: 0,
          f46: 0,
          h36: 0,
          h38: 0,
          h40: 0,
          h42: 0,
          h44: 0,
          h46: 0,
          ftotpcs: 0,
          htotpcs: 0,
          totpcs: 0,
          totamt: 0,
          barcodedel: "",
        };
        that.salesdata.design_no = "";
        $("#filter").focus();
      }
    }
  }

  getReturnDeduction() {

    //For Return Deduction Amt purpose(If It fails For p.Voucher Purpose pls use tot_pcs for calculate Amt(tot_pcs * default_amt(40/20/150)))
    if (this.designList[this.designList.length - 1].dcdt > "2020-04-01") {

      if (Number(this.designList[this.designList.length - 1].dif_days) < 60) {

        // below days
        if (this.designList[this.designList.length - 1].box_type == "WITH BOX") {
          this.designList[this.designList.length - 1].ded_amt = 40

        } else if (this.designList[this.designList.length - 1].box_type == "W/O BOX") {
          this.designList[this.designList.length - 1].ded_amt = 20
        }
      } else if (Number(this.designList[this.designList.length - 1].dif_days) > 60) {
        // above days

        this.designList[this.designList.length - 1].ded_amt = 150
      }
      this.returndata.ded_tot += this.designList[this.designList.length - 1].ded_amt;
    }

  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }
  calcdisper() {
    if (isNaN(this.returndata.disper)) {
      this.returndata.disper = 0;
    }
    this.returndata.disamt =
      (this.wodata.totalamt * this.returndata.disper) / 100;
    this.returndata.disamt = parseFloat(this.returndata.disamt.toFixed(2));
    this.calcTotal();
  }

  calctaxper() {
    if (this.returndata.ret_type == "PIECE") {
      if (isNaN(this.returndata.taxper) || this.returndata.taxper == null) {
        this.returndata.taxper = 0;
      }
      if (isNaN(this.returndata.transport)) {
        this.returndata.transport = 0;
      }
      this.returndata.tot_amt =
        (this.wodata.totalamt - this.returndata.disamt +
          Number(this.returndata.transport) -
          this.returndata.boxless)
      this.returndata.taxamt = (this.returndata.tot_amt * this.returndata.taxper) / 100;
      this.returndata.taxamt = parseFloat(this.returndata.taxamt.toFixed(2));
    } else if (this.returndata.ret_type != "PIECE") {
      if (isNaN(this.returndata.taxper) || this.returndata.taxper == null) {
        this.returndata.taxper = 0;
      }

      this.returndata.taxamt =
        (this.returndata.tot_amt * this.returndata.taxper) / 100;
      this.returndata.taxamt = parseFloat(this.returndata.taxamt.toFixed(2));

      this.returndata.retamt = this.returndata.tot_amt + this.returndata.taxamt;

      this.returndata.retamt = parseFloat(this.returndata.retamt.toFixed(2));

      this.returndata.retamt = Math.round(this.returndata.retamt);
      return;
    }
    this.calcTotal();
  }

  calcTotal() {

    if (this.mode == 'View') {
      return
    }
    this.wodata.fullrate = _.sumBy(this.designList, function (o) {
      return o["fqty"] != "" ? parseInt(o["fqty"]) : 0;
    });
    this.wodata.halfrate = _.sumBy(this.designList, function (o) {
      return o["hqty"] != "" ? parseInt(o["hqty"]) : 0;
    });
    this.wodata.totalrate = _.sumBy(this.designList, function (o) {
      return o["totqty"] != "" ? parseInt(o["totqty"]) : 0;
    });
    this.wodata.totalamt = _.sumBy(this.designList, function (o) {
      return o["totamt"] != "" ? parseInt(o["totamt"]) : 0;
    });

    this.returndata.retamt =
      this.wodata.totalamt -
      parseFloat(this.returndata.disamt) +
      parseFloat(this.returndata.taxamt) +
      parseFloat(this.returndata.roundoff) -
      this.returndata.boxless +
      Number(this.returndata.transport);

    this.returndata.retamt = this.returndata.retamt + (this.returndata.oth_amt || 0);

    this.returndata.retamt = parseFloat(this.returndata.retamt.toFixed(2));

    // if(this.mode == 'Edit' && this.returndata.ret_type != "PIECE"){
    //   this.calctaxper()

    // }

  }

  deleterow(ind) {
    this.designList.splice(ind, 1);
  }

  getAuto() {
    let type = "";
    if (this.returndata.retbill_type == "WHOLESALE" || this.returndata.retbill_type == "OLIVE") {
      type = "salesInvRtn-wholesale";
    } else if (this.returndata.retbill_type == "RETAIL") {
      type = "salesInvRtn-retail";
    } else if (this.returndata.retbill_type == "PROFORMAWHOLESALE") {
      type = "salesInvRtn-proforma";
    }
    let params = {
      trans_type: type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    this.salesservice.getAutoNumber(params).then((res: any) => {
      this.returndata.creditno = res.auto_no;
    });
  }

  getDesignNoList() {
    this.designservice.getDesignNoList({}).then((res: any) => {
      this.designnoList = res;
    });
  }

  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
      if (this.mode == "Convert_type") {
        this.selectParty(this.returndata.party_name);
      }
    });
  }

  onSelectdesign($event) {
    let params = {
      design_id: $event.item.design_id,
      party_id: "",
      page: 1,
      start: 0,
      limit: 100,
    };
    this.salesdata.design_id = $event.item.design_id;
    this.salesservice.getSalesInvNoCombo(params).then((res: any) => {
      this.invoiceList = res;
    });
  }

  onselectinvoice(invoiceno) {
    //   this.salesdata.dcid = invoice.dcid;
    if (invoiceno >= 0) {
      if (this.returndata.retbill_type == "RETAIL") {
        let params = {
          invoiceno: invoiceno,
          billType: "retail",
        };
        this.salesservice.getdcid(params).then((res: any) => {
          this.salesdata.dcid = res[0].dcid;
          this.salesdata.invoiceno = res[0].invoice_no;
          // this.returndata.type_check = "olive";
          // this.multiList.push(this.salesdata);
       
        });
      } else if (this.returndata.retbill_type == "WHOLESALE" || this.returndata.retbill_type == "OLIVE" || this.returndata.retbill_type == "PROFORMAWHOLESALE") {
        let params = {
          invoiceno: invoiceno,
          entry_type: this.returndata.retbill_type
        };
        this.salesservice.getdcid(params).then((res: any) => {
          this.salesdata.dcid = res[0].dcid;
          this.salesdata.invoiceno = res[0].invoice_no;
        });
      }
    }
  }

  onselectinvoiceMultiple(invoiceno) {
    this.returndata.invoice_no = invoiceno;
    //   this.salesdata.dcid = invoice.dcid;
    if (invoiceno >= 0) {
      if (this.returndata.retbill_type == "WHOLESALE") {
        let params = {
          invoiceno: invoiceno,
          type: "Multiple",
        };
        this.salesservice.getdcid(params).then((res: any) => {
          this.salesdata.dcid = res[0].dcid;
          this.salesdata.invoiceno = res[0].invoice_no;
          this.returndata.type_check = "olive";
          this.multiList.push(this.salesdata);
        
        });
      }

      // if (this.returndata.retbill_type == "RETAIL") {
      //   let params = {
      //     invoiceno: invoiceno,
      //     billType: "retail",
      //   };
      //   this.salesservice.getdcid(params).then((res: any) => {
      //     this.salesdata.dcid = res[0].dcid;
      //     this.salesdata.invoiceno = res[0].invoice_no;
      //     // this.returndata.type_check = "olive";
      //     // this.multiList.push(this.salesdata);
      //     console.log(this.multiList);
      //   });
      // }
    }
  }
  onSelectfilter($event) {
    //
    this.salesdata.filter = $event.item.categoryname;
    this.salesdata.category_id = $event.item.categoryid;
    this.salesdata.fsrate = $event.item.fsrate;
    this.salesdata.hsrate = $event.item.hsrate;
    // $('#design').focus();
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      this.seasonList = res;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  onSelectSeason($event) {
    this.salesdata.season_year = $event.season_year;
  }

  selectParty(party_name) {
    let that = this;
    that.partyList.forEach(function (key) {
      if (key.name == party_name) {
        that.returndata.party_id = key.genLedid;
        that.returndata.agentid = key.agent_id;
        that.returndata.transport = key.transport;
        return false;
      }
    });
    // this.returndata.party_id = $event.genLedid;
    // this.returndata.agentid = $event.agent_id;
  }

  checkBarcode(barcode) {
    let notExist: boolean = true;
    for (let i = 0; i < this.designList.length; i++) {
      let code = parseInt(barcode);
      this.designList[i].barcodedel = parseInt(this.designList[i].barcodedel);
      if (this.designList[i].barcodedel == code) {
        notExist = false;
      }
    }

    if (notExist) {
      this.getSalesInvRtnFilterBy(barcode);
    } else {
      setTimeout(() => {
        this.salesdata.filter = "";
        $("#filter").focus();
      }, 500);
      swal({
        title: "Barcode Already Exists",
        timer: 1000,
        type: "warning",
        showCancelButton: false,
        showConfirmButton: false,
      });
      return;
    }
  }

  getSalesInvRtnFilterBy(barcode) {
    if (barcode.length !== 7) {
      return false;
    }
    let params = {
      barcode: barcode,
      ret_date: this.returndata.retdate,
      inv_type: this.returndata.retbill_type

    };

    this.salesservice.getSalesInvRtnFilterBy(params).then((res: any) => {
      if (res == false) {
        this.salesdata.filter = "";
        swal({
          title: "Barcode Invalid",
          timer: 1000,
          type: "warning",
          showCancelButton: false,
          showConfirmButton: false,
        });
        return false;
      }
      if (!res.color && res.brand != "OLIVE") {
        swal(
          "Color is Empty for the Barcode " +
          "<b style='color:blue'>" +
          barcode +
          "</b>"
        );
        this.salesdata.filter = "";
        return;
      }
      this.salesdata = res;

      this.salesdata.f36 = parseInt(res.f36);
      this.salesdata.f38 = parseInt(res.f38);
      this.salesdata.f40 = parseInt(res.f40);
      this.salesdata.f42 = parseInt(res.f42);
      this.salesdata.f44 = parseInt(res.f44);
      this.salesdata.f46 = parseInt(res.f46);
      this.salesdata.h36 = parseInt(res.h36);
      this.salesdata.h38 = parseInt(res.h38);
      this.salesdata.h40 = parseInt(res.h40);
      this.salesdata.h42 = parseInt(res.h42);
      this.salesdata.h44 = parseInt(res.h44);
      this.salesdata.h46 = parseInt(res.h46);
      this.salesdata.addToStock = this.addToStock;
      this.salesdata.barcodedel = res.barcodedel;
      this.inv_date = res.inv_date;
      this.salesdata.view_type = this.returndata.ret_type;
      this.dif_date = res.dif_days;
      this.dcdt = res.dcdt;

      this.calcTot();
      this.pushrow();
    });
  }
  barcodeExist() {
    // if(this.barcodeVal){
    //     this.barcodeVal=false;
    // }
    // else{
    //     this.barcodeVal=true;
    // }
  }
  calcMultipcs(ind) {
    let temp_check = false
    if (this.returndata.retbill_type == "OLIVE") {
      temp_check = true;
    }

    if (temp_check) {
      this.designList[ind].fqty =
      this.designList[ind].f36 +
      this.designList[ind].f38 +
      this.designList[ind].f40 +
      this.designList[ind].f42 +
      this.designList[ind].f44 +
      this.designList[ind].f46;
     this.designList[ind].hqty =
      this.designList[ind].h36 +
       this.designList[ind].h38 +
      this.designList[ind].h40 +
      this.designList[ind].h42 +
      this.designList[ind].h44 +
      this.designList[ind].h46;
      this.designList[ind].totqty = this.designList[ind].fqty + this.designList[ind].hqty
      this.salesdata.ftotpcs =  this.designList[ind].fqty;
      this.salesdata.htotpcs = this.designList[ind].hqty;
    this.returndata.ftotpcs = this.salesdata.ftotpcs;
    this.returndata.htotpcs = this.salesdata.htotpcs;
    this.salesdata.totpcs = this.salesdata.ftotpcs + this.salesdata.htotpcs;
    this.returndata.totpcs = this.salesdata.totpcs;
    this.salesdata.totamt =
      this.salesdata.ftotpcs * Number(this.designList[ind].fsrate) +
      this.salesdata.htotpcs * Number(this.designList[ind].hsrate);
    this.returndata.totamt = this.salesdata.totamt;
    this.returndata.totamt = this.salesdata.totamt;
    this.designList[ind].totamt = this.returndata.totamt
  

    }
    // console.log("wholesaelCallllllllllllll")
  }
  selectType() {
    this.type = this.salesdata.type;
  }
  designNo(id) {
    //   let params={
    //         query: id,
    //         categoryid: this.salesdata.filter,
    //         todo: 'getSalesInvRtnDesignList',
    //         page: 1,
    //         start: 0,
    //         limit: 100
    //   }
    //   this.salesservice
    //     .designNo(params)

    //     .then((res: any) => {
    //             this.designnoList = res;
    //         });
    // let that = this;
    // this.designnoList.forEach(function (element) {
    this.salesdata.design_id = id.item.design_id;
    this.salesdata.des_id = id.item.des_id;
    this.salesdata.color = id.item.color;
    this.salesdata.design_no = id.item.design_no;
    this.salesdata.design = id.item.design_no;
    this.salesdata.fsrate = id.item.fsrate;
    this.salesdata.hsrate = id.item.hsrate;

    // })
  }

  oncheckemptyrow() {
    let design = this.designList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      //  if (design[i].color !== '') {
      desList.push(design[i]);
      //   }
    }
    this.designList = desList;
    this.onSaveOrder();
  }

  printdata(printData) {
    let params = {
      noofpcs: 2,
      designdet: JSON.stringify(printData),
    };
    this.designservice.print(params);
  }

  onSaveOrder() {
    this.narr = false;
    let params: any = Object.assign({}, this.returndata);
    params["tabevent"] = undefined;
    params["mode"] = this.mode;
    params["ret_id"] = this.ret_id;
    params["salInvRtnGrid"] = JSON.stringify(this.designList);
    params["saleMultiList"] = JSON.stringify(this.multiList);
    params["retdate"] = this.datePipe.transform(
      params["retdate"],
      "yyyy-MM-dd"
    );

    if (this.returndata.oth_amt === null) {
      swal("warning", "Please add valid other amount");
    } else if (this.returndata.oth_amt !== 0) {
      if (this.returndata.narration === "") {
        swal("warning", "Please add comments");
      } else {
        this.narr = true;
      }
    } else {
      this.narr = true;
    }

    if (this.narr == true) {
      let that = this;
      that.isLoading = true;
      if (that.mode == "Add") {
        swal({
          title: "Are you sure to save this Return Details?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, save it!",
          cancelButtonText: "No, want to change",
        }).then(function () {
          that.isLoading = true;
          that.salesservice
            .addSalesInvRtn(params)
            .then(function (res: any) {
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                //    that.printdata(res.printData);
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        });
      } else {
        that.isLoading = true;
        that.salesservice.updateSalesInvRtn(params).then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.printdata(res.printData);
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesReturn/addEditSalesReturn.ts